import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft, Trophy, ShoppingBag, Sparkles } from "lucide-react";
import PhoneFrame from "../components/PhoneFrame.jsx";
import BottomNav from "../components/BottomNav.jsx";
import api from "../lib/api.js";

export default function Rewards() {
  const nav = useNavigate();
  const [dash, setDash] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/dashboard").then((r) => setDash(r.data));
    api.get("/marketplace").then((r) => setProducts(r.data));
  }, []);

  return (
    <PhoneFrame>
      <div className="px-5 pt-6 pb-28">
        <button onClick={() => nav(-1)} className="text-slate-400 inline-flex items-center gap-1 text-sm" data-testid="rewards-back">
          <ChevronLeft size={16} /> Back
        </button>
        <h1 className="ps-heading text-3xl font-bold mt-4">Rewards</h1>

        <div className="mt-5 rounded-3xl p-6 bg-gradient-to-br from-[#2fbf71]/20 to-[#00B4D8]/10 border border-[#2fbf71]/30 text-center">
          <Trophy size={28} color="#2fbf71" className="mx-auto" />
          <div className="text-xs uppercase tracking-widest text-[#2fbf71] font-bold mt-2">Posture Points™</div>
          <div className="ps-heading text-5xl font-bold mt-1" data-testid="rewards-points">{dash?.points ?? 0}</div>
          <div className="text-xs text-slate-400 mt-1">Earn points by walking, posture sessions, check-ins & more.</div>
        </div>

        <div className="mt-6">
          <div className="text-xs uppercase tracking-widest text-slate-400 font-bold mb-3">Ways to Earn</div>
          <div className="grid grid-cols-2 gap-3">
            {[
              { l: "Walk 1,000 steps", p: "10 pts" },
              { l: "10-min posture session", p: "50 pts" },
              { l: "Daily check-in", p: "25 pts" },
              { l: "30-min passive session", p: "+24 pts" },
              { l: "Complete challenge", p: "100-1000 pts" },
              { l: "Invite a friend", p: "200 pts" },
            ].map((x) => (
              <div key={x.l} className="ps-card p-3 text-xs">
                <div className="font-semibold">{x.l}</div>
                <div className="text-[#2fbf71] mt-1">{x.p}</div>
              </div>
            ))}
          </div>
        </div>

        <Link to="/marketplace" data-testid="rewards-to-marketplace" className="mt-6 block ps-card-elev p-5 flex items-center gap-4 hover:border-[#2fbf71]/40">
          <div className="w-12 h-12 rounded-2xl bg-[#142534] flex items-center justify-center">
            <ShoppingBag size={22} color="#2fbf71" />
          </div>
          <div className="flex-1">
            <div className="font-semibold ps-heading">Visit Marketplace</div>
            <div className="text-xs text-slate-400">Back Transformer™, posture gear, and more</div>
          </div>
          <Sparkles size={18} color="#2fbf71" />
        </Link>

        <div className="mt-6">
          <div className="text-xs uppercase tracking-widest text-slate-400 font-bold mb-3">Featured Rewards</div>
          <div className="grid grid-cols-2 gap-3">
            {products.slice(0, 4).map((p) => (
              <Link key={p.id} to="/marketplace" className="ps-card p-3" data-testid={`reward-prod-${p.id}`}>
                <div className="aspect-square rounded-xl overflow-hidden bg-[#142534]">
                  <img src={p.image_url} alt={p.name} className="w-full h-full object-cover" />
                </div>
                <div className="mt-2 text-xs font-semibold line-clamp-1">{p.name}</div>
                <div className="text-[10px] text-[#2fbf71] mt-1">From {p.discount_tiers?.[0]?.points ?? 0} pts</div>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <BottomNav />
    </PhoneFrame>
  );
}
